<template>
  <div class="d-flex flex-column align-center justify-center w100 mt-8 ga-6">
    <div class="d-flex flex-column align-center ga-1">
      <div
        style="border-radius: 100px; background-color: #43BA7E; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;"
        class="pa-3 mb-3"
      >
        <v-icon style="font-size: 40px; color: #fff;">
          mdi-package-variant-closed
        </v-icon>
      </div>

      <h1>Raw Material Receiving</h1>
      <span style="color: rgba(0,0,0,0.6); font-size: 20px; font-weight: 500;">Enter your Purchase Order number to view and process incoming materials</span>
    </div>
    <div
      class="d-flex flex-column pa-5"
      style="border: 1px solid #E4E4E7; border-radius: 14px; min-width: 700px;"
    >
      <div class="d-flex align-center ga-2">
        <v-icon style="font-size: 30px; color: #43BA7E;">
          mdi-magnify
        </v-icon>
        <h2>Purchase Order Lookup</h2>
      </div>

      <p>Enter the Inventory/Installation PO# to retrieve order details</p>
      <div class="d-flex ga-5">
        <v-form
          ref="form"
          class="w100"
        >
          <v-text-field
            v-model="inventoryPoNumber"
            outlined
            @keydown.enter="submit()"
            placeholder="e.g., 123456"
          />
        </v-form>

        <v-btn
          class="pl-10 pr-10 pt-7 pb-7"
          color="#43BA7E"
          style="border-radius: 6px;"
          :disabled="!inventoryPoNumber"
          @click="submit()"
        >
          <span style="font-size: 18px; color: #fff;">Search</span>
        </v-btn>
      </div>
    </div>
    <InventoryPoReceivingForm ref="refForm" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import InventoryPoReceivingForm from '@/components/forms/inventoryPos/InventoryPoReceivingForm.vue';

export default {
  components: {
    InventoryPoReceivingForm,
  },
  props: {

  },
  data: () => ({
    inventoryPoNumber: null,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
  },
  watch: {

  },
  created() {
    this.init();
  },
  methods: {
    init() {

    },

    async submit() {
      const valid = await this.$refs.form.validate();

      if (!valid) return;

      this.$refs.refForm.open(this.inventoryPoNumber);
    },
  },
};
</script>

<style scoped>

</style>
